import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private authStore = inject(AuthStore);
  private router = inject(Router);

  canActivate(): boolean {
    const isAuthInitialized = this.authStore.isAuthInitialized();
    const isAuthenticated = this.authStore.isAuthenticated();
    
    // If auth is not initialized yet, allow access (will be handled by auth state change)
    if (!isAuthInitialized) {
      return true;
    }
    
    if (!isAuthenticated) {
      this.router.navigate(['/login']);
      return false;
    }
    
    return true;
  }
}